import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import ProjectDetail from '../../project/project-detail';
import SaleDetail from '../../sale-detail';

export default function SaleProject() {
  const { t } = useTranslation();

  return (
    <>
      <Text variant="HeadingXSmall">
        {t('common:remove_invoice_from_project')}
      </Text>
      <Separator gap={16} />
      <ProjectDetail name="approvalable.project" />
      <Separator gap={16} />
      <SaleDetail forceShowDetail />
    </>
  );
}
